<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed, ref, useId, useTemplateRef, watch } from "vue";
import Allergen from "#/assets/iconsDynamic/Allergen.vue";
import ChevronRight from "#/assets/iconsDynamic/ChevronRight.vue";
import { useCardStore } from "#/store/card";
import { collectAllergens } from "#/utils/allergens";

const cardStore = useCardStore();
const { t, i18next } = useTranslation();

const panelId = useId();
const rootElement = useTemplateRef<HTMLElement>("rootElement");
const isExpanded = ref(false);

const allergens = computed(() => collectAllergens(cardStore.stateCard.openCard, cardStore.stateCard.groupModifiersSelected, i18next.language));
const allergensText = computed(() => allergens.value.join(", "));

const toggle = () => {
	isExpanded.value = !isExpanded.value;
};

/** Блок стоит в самом низу карточки — после раскрытия докручиваем, чтобы список не уходил под кнопку добавления. */
const onPanelTransitionEnd = (event: TransitionEvent) => {
	if (event.propertyName !== "grid-template-rows" || !isExpanded.value) return;
	rootElement.value?.scrollIntoView({ block: "nearest", behavior: "smooth" });
};

watch(
	() => cardStore.stateCard.openCard?.id,
	() => {
		isExpanded.value = false;
	},
);
</script>

<template>
	<div v-if="allergens.length" ref="rootElement" class="product_allergens" :class="{ product_allergens_expanded: isExpanded }">
		<button type="button" class="product_allergens_header" :aria-expanded="isExpanded" :aria-controls="panelId" @click="toggle">
			<Allergen class="product_allergens_icon" />
			<span class="product_allergens_title">
				<span class="product_allergens_label">{{ t(`card.allergens`) }}:</span>
				<span v-if="!isExpanded" class="product_allergens_preview">{{ allergensText }}</span>
			</span>
			<ChevronRight class="product_allergens_chevron" />
		</button>
		<div :id="panelId" class="product_allergens_panel" :aria-hidden="!isExpanded" @transitionend.self="onPanelTransitionEnd">
			<div class="product_allergens_panel_inner">
				<ul class="product_allergens_list">
					<li v-for="name in allergens" :key="name" class="product_allergens_item">{{ name }}</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
  @use './productAllergens.scss';
</style>
